import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import deutsch from '../translations/de.json';
import english from '../translations/en.json';

const resources = {
  en: english,
  de: deutsch
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    resources,
    lng: 'de',
    fallbackLng: 'en',
    keySeparator: '->',
    interpolation: {
      escapeValue: false,
      skipOnVariables: false
    }
  });

export default i18n;
